const helpers = {
  createID: () => { return parseInt(Math.random() * 1000000000) },
  isEqual: (obj1, obj2) => {
    return JSON.stringify(obj1) == JSON.stringify(obj2)
  },
  validateBotData: (data) => {
    for (let dialogue of data) {
      dialogue.dialogue_name = dialogue.dialogue_name.trim()
      dialogue.dialogue_command = dialogue.dialogue_command.trim()
      for (let node of dialogue.dialogue_nodes) {
        node.text = node.text.trim()
      }
    }
    return data
  },
  focusOnInputAfterModalOpen(selector, time) {
    setTimeout(() => {
      document.querySelector(selector).focus();
    }, time);
  },
  scrollElementIntoView(selector, options) {
    const element = document.getElementById(selector);
    if (element) { element.scrollIntoView(options)}
  }
}

export default helpers